export const environment = {
    production: false,
    apiUrl: 'https://juriapi.dev.devplusapp.com/api',
    hubUrl: 'http://localhost:5068',
    versionApi: '/v1',
    clienteServiceApi: '/clientes',
    produtoServiceApi: '/produto',
    pagamentoServiceApi: '/condpgto',
    enderecoServiceApi: '/cadastrohelper/enderecov2',
    tagVersion: '[DC]',
};
